import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// import Banner from "../../assets/img/axisdent/acasa/background-section2.png"
import SubHeader2 from "../../assets/img/axisdent/subheader-bl.png"
import SubHeader1 from "../../assets/img/axisdent/subheader-br.png"
import SubHeader3 from "../../assets/img/axisdent/subheader-tr.png"

class Breadcrumbs extends Component {
    render() {
        return (
            <div className="sigma_subheader style-5 bg-gray">
                <div className="container">
                    <div className="sigma_subheader-inner">
                        <h1>{this.props.breadcrumb.pagename}</h1>
                    </div>
                    <ol style={{marginTop: '10px'}} className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/" className="btn-link">Acasă</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">{this.props.breadcrumb.pagename}</li>
                    </ol>
                </div>
                <img src={SubHeader1} className="br" alt="subheader" />
                <img src={SubHeader2} className="bl" alt="subheader" />
                <img src={SubHeader3} className="tr" alt="subheader" />
            </div>
        );
    }
}

export default Breadcrumbs;
